import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import { useKioskoBySlug } from "../../../../services/microservice/agents/sponsors/use-sponsors";
import { IKioskoConfig } from "../../../../components/kiosko/context/kiosko-config.context";

interface IProps {
  children: ReactNode;
}

interface IAuthAgentAdmin {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgentAdmin | null;
  setStep: Dispatch<SetStateAction<number>>;
  setUser: Dispatch<SetStateAction<IAuthAgentAdmin | null>>;
  sponsor: string;
  config?: IKioskoConfig;
};

export const AgentsAdminContext = React.createContext<IContext>({} as IContext);

export const useAgentsAdminContext = () =>
  useContext<IContext>(AgentsAdminContext);

const AdminAgentsProvider = ({ children }: IProps) => {
  const { pathname } = useLocation();
  const sponsor = pathname.split("/")[1];
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgentAdmin | null>(null);
  // Branding del sponsor (logo/colores) desde el detalle. Si falla (ej. kiosko
  // deshabilitado), los layouts/navbar caen a su branding hardcodeado.
  const { data: config } = useKioskoBySlug(sponsor);
  const context: IContext = useMemo(
    () => ({
      step,
      user,
      sponsor,
      config,
      setStep,
      setUser,
    }),
    [step, user, sponsor, config],
  );
  return (
    <AgentsAdminContext.Provider value={context}>
      {children}
    </AgentsAdminContext.Provider>
  );
};

export default AdminAgentsProvider;
